import axios from "axios";
import { baseUrl } from "../util/constant";
import { store } from "../store/store";
import { logout } from "../slices/userSlice";
import { clearServerSession, clearSessionCache } from "./sessionCache";

export class AxiosInstanceService {
    static ApiAxiosInstance;
    static isClearingSession = false;
    static async getAxiosInstance() {
        if (this.ApiAxiosInstance) return Promise.resolve(this.ApiAxiosInstance);

        //create instance 
        this.ApiAxiosInstance = axios.create({
            withCredentials: true,
            baseURL: baseUrl,
            headers: { 'Content-Type': 'application/json' },

        })
        // Add interceptor to handle 401 responses
        this.ApiAxiosInstance.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (error.response && error.response.status === 401) {
                    if (!AxiosInstanceService.isClearingSession) {
                        AxiosInstanceService.isClearingSession = true;
                        try {
                            await clearServerSession();
                            store.dispatch(logout());
                            await clearSessionCache();
                        } finally {
                            AxiosInstanceService.isClearingSession = false;
                        }
                    }
                }
                return Promise.reject(error);
            }
        );
        return Promise.resolve(this.ApiAxiosInstance);
    }


}
